import React from "react";
import { useNavigate } from "react-router-dom";

const MeetingTracker = () => {
  const navigate = useNavigate();
  return (
    <div className="meettracker_sec">
      <div className="row">
        <div className="qep_grad mt-4">
          <h2>Quality Council Meeting Tracker</h2>
        </div>
        <div className="council_meet">
          <div className="">
            <label htmlFor="dueDate">Last Meeting Date</label>
            <input type="date" id="dueDate" className="form-control" />
          </div>
          <div className="">
            <label htmlFor="dueDate">Next Meeting Due</label>
            <input type="date" id="dueDate" className="form-control" />
          </div>
          <div className="">
            <label className="form-label">Name</label>
            <input
              type="text"
              className="form-control"
              id="exampleFormControlInput1"
              placeholder="Enter name"
            />
          </div>
          <div className="">
            <label className="form-label">Email</label>
            <input
              type="email"
              className="form-control"
              id="exampleFormControlInput1"
              placeholder="Enter email address"
            />
          </div>
          <div className="">
            <label className="form-label">Role</label>
            <select
              className="form-select mb-3"
              aria-label="Default select example"
            >
              <option selected>Select role</option>
              <option value="1">One</option>
              <option value="2">Two</option>
              <option value="3">Three</option>
            </select>
          </div>
        </div>
        <div className="goal_left">
          <div className="mb-4">
            <label className="form-label">
              Meeting Agenda
              <span className="sep_cont">(Required)</span>
            </label>

            <textarea
              className="form-control"
              id="exampleFormControlTextarea1"
              rows={3}
              placeholder="Enter planned agenda items here..."
            ></textarea>
          </div>
        </div>
        <div className="qep_grad">
          <h2>Meeting Notes</h2>
        </div>

        <div className="col-lg-6">
          <div className="goal_left">
            <div className="mb-3">
              <label className="form-label">Performance Review</label>

              <textarea
                className="form-control"
                id="exampleFormControlTextarea1"
                rows={3}
                placeholder="System Summary: 92% service delivery, 3 CIRs, 2 gaps in plan compliance."
              ></textarea>
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="goal_left">
            <div className="mb-3">
              <label className="form-label">Stakeholder Feedback</label>

              <textarea
                className="form-control"
                id="exampleFormControlTextarea1"
                rows={3}
                placeholder="System Summary: 89% satisfaction rate from 104 responses, 6 complaint patterns."
              ></textarea>
            </div>
          </div>
        </div>
        <div className="col-lg-5">
          <div className="mb-3">
            <label className="form-label">Goal</label>
            <input
              type="text"
              className="form-control"
              id="exampleFormControlInput1"
              placeholder="Improve staff training compliance"
            />
          </div>
        </div>
        <div className="col-lg-5">
          <div className="mb-3">
            <label className="form-label">Subgoal</label>
            <input
              type="text"
              className="form-control"
              id="exampleFormControlInput1"
              placeholder="Enter your subgoal"
            />
          </div>
        </div>
        <div className="col-lg-2">
          <div className="mb-3">
            <label className="form-label">Due Date</label>
            <input
              type="date"
              className="form-control"
              id="exampleFormControlInput1"
              placeholder="Select date"
            />
          </div>
        </div>
        <div className="col-lg-4">
          <div className="goal_left">
            <div className="mb-3">
              <label className="form-label">Root Cause Analysis</label>

              <textarea
                className="form-control"
                id="exampleFormControlTextarea1"
                rows={3}
                placeholder="System Suggestion: Training gaps and staff turnover correlated with missed visits."
              ></textarea>
            </div>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="goal_left">
            <div className="mb-3">
              <label className="form-label">Adjustments</label>

              <textarea
                className="form-control"
                id="exampleFormControlTextarea1"
                rows={3}
                placeholder="System is monitoring unmet indicators for automatic reassignment."
              ></textarea>
            </div>
          </div>
        </div>
        <div className="goalsave_btn meeting_btn">
          <input
            type="submit"
            className="form-control"
            id="exampleFormControlInput1"
            value=" Send Meeting Invite"
            onClick={() => navigate("/dashboard/owner/qep/meetinginvite")}
          />
        </div>
      </div>
    </div>
  );
};

export default MeetingTracker;
